import * as types from 'constants/ActionTypes';
import { createReducer } from 'utils/ReduxUtils';

/** @type {import('modules/statistics/types').AllDealersStatisticsReducer} */
export const initialState = {
  accepted: 0,
  acceptedOn: 0,
  amountRatio: 0,
  checklistProposed: 0,
  conversionRatio: 0,
  hasAcceptedAdvice: 0,
  hasVideo: 0,
  modeSales: 0,
  modeTechnician: 0,
  moduleBodywork: 0,
  moduleBodyworkAppointment: 0,
  moduleGuarantee: 0,
  moduleMechanic: 0,
  moduleReminder: 0,
  moduleSalesMessage: 0,
  moduleStockVo: 0,
  moduleTires: 0,
  proposed: 0,
  sent: 0,
};

/**
 * @param {import('modules/statistics/types').AllDealersStatisticsReducer} state
 * @param {import('modules/statistics/types').FetchAllDealersStatsSuccessAction} action
 * @returns {import('modules/statistics/types').AllDealersStatisticsReducer}
 */
const updateData = (state, { payload }) => {
  const isFirstPage = payload.page.number === 0;
  if (isFirstPage) {
    return { ...initialState, ...(payload.content?.[0] ?? {}) };
  }
  return state;
};

/** @returns {import('modules/statistics/types').AllDealersStatisticsReducer} */
const resetData = () => ({ ...initialState });

export default createReducer(initialState, {
  [types.FETCH_STATISTICS_ALL_DEALERS_FAILURE]: resetData,
  [types.FETCH_STATISTICS_ALL_DEALERS_SUCCESS]: updateData,
});
